"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GroupDinnerComponent',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        pointsSwitch: true,
        balancePaySwitch: true,
        lunchBoxFeeSwitch: true
      },
      id: null,
      loading: false
    };
  },
  mounted: function mounted() {
    this.loadConfig();
  },
  methods: {
    // 加载配置
    loadConfig: function loadConfig() {
      var _this = this;
      if (this.pageKey && this.moduleKey) {
        this.loading = true;
        (0, _decorateConfig.getDecorateConfig)(this.pageKey, this.moduleKey).then(function (response) {
          if (response && response.data) {
            try {
              var configInfo = JSON.parse(response.data.configInfo);
              _this.form = {
                pointsSwitch: configInfo.pointsSwitch !== undefined ? configInfo.pointsSwitch : true,
                balancePaySwitch: configInfo.balancePaySwitch !== undefined ? configInfo.balancePaySwitch : true,
                lunchBoxFeeSwitch: configInfo.lunchBoxFeeSwitch !== undefined ? configInfo.lunchBoxFeeSwitch : true
              };
              _this.id = response.data.id;
            } catch (error) {
              console.error('解析配置失败:', error);
              _this.$message.warning('配置解析失败，使用默认值');
            }
          }
        }).catch(function (error) {
          console.error('获取配置失败:', error);
          _this.$message.warning('获取配置失败，使用默认值');
        }).finally(function () {
          _this.loading = false;
        });
      }
    },
    // 保存配置
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!this.pageKey || !this.moduleKey)) {
                _context.next = 1;
                break;
              }
              this.$message.error('页面参数不完整');
              return _context.abrupt("return");
            case 1:
              _context.prev = 1;
              this.loading = true;
              data = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                configInfo: JSON.stringify(this.form)
              };
              _context.next = 2;
              return (0, _decorateConfig.saveDecorateConfig)(data);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                this.$message.success('保存成功');
                // 保存成功后重新查询配置
                this.loadConfig();
              } else {
                this.$message.error('保存失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('保存配置失败:', _t);
              this.$message.error('保存失败');
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 重置配置
    handleReset: function handleReset() {
      this.form = {
        pointsSwitch: true,
        balancePaySwitch: true,
        lunchBoxFeeSwitch: true
      };
      this.$message.info('已重置为默认配置');
    }
  }
};